<template>
  <div class="pa-4 text-center">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="justify-content-between align-items-center">
        <div v-if="valorCode" class="countdown-container">
          <div class="containerTime">
            <span>Tiempo de validez del código</span>
            <p id="countdown" style="color: black; font-weight: bold;"></p>
          </div>
        </div>
        <button class="close-button" @click="closeDialog">
          <span class="small-x" style=" color: #6E17A5; font-size: 18px; width: 35px; height: 35px;">X</span>
        </button>
        <img class="container justify-content-between align-items-left"
          src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" />
        <h2 style="text-align: center; color: #6E17A5;">Código de confirmación</h2>
        <v-col cols="12">
          <v-container>
            <v-col cols="12" md="12" sm="12" style="text-align: center;">
              <v-text-field id="correo" label="Código" placeholder="Ingrese el código" append-icon="mdi mdi-account-outline" outlined color="primary" v-model="formData.code" :rules="codeRules" :counter="15" :maxlength="15" required></v-text-field>
              <span class="code-text">¿No te llegó el código?</span>
              <br>
              <button class="code-text" :style="{ color: showResendButton ? '#6E17A5 ' : 'grey', 'font-weight': showResendButton ? 'bold' : 'normal' }" @click="resendCode" :disabled="!showResendButton || isResendButtonDisabled">Reenviar</button>
            </v-col>
            <v-spacer></v-spacer>

            <v-btn large block rounded color="primary" class="12" md="12" sm="6"
              style="color: white; border-radius: 50px;" :disabled="!isCodeValid || showResendButton" @click="changeValidateCode">
              Verificar
            </v-btn>
            <v-spacer></v-spacer>
          </v-container>
        </v-col>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  RECOVER_FORGOTTEN_PASSWORD_M,
  ACTION_POST_VALIDATETOKEN,
  ACTION_GET_RESENDTOKEN
} from "@/views/recover_forgotten_password/store/types/types.js";

import { mapActions } from 'vuex';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';

const alphanumericRule = /^[a-zA-Z0-9]{15}$/;

export default {
  name: "formValidationCode",

  props: {
    valorCode: {
      required: true,
      type: Number
    },
  },

  data() {
    return {
      dialog: true,
      segundos: this.valorCode * 60,
      countdown: null,
      showResendButton: false,
      isResendButtonDisabled: false,
      formData: {
        code: ''
      },

      codeRules: [
        v => !!v || "El código es requerido",
        v => alphanumericRule.test(v) || "El formato del código es inválido"
      ],
      showErrorMessages: false,
    }

  },

  computed: {

    isCodeValid() {
      return this.formData.code && alphanumericRule.test(this.formData.code);
    }

  },
  mounted() {
    if (this.valorCode) {
      this.startCountdown();
    }
  },

  methods: {

    closeDialog() {
      EventBus.$emit('close-dialog');
      sessionStorage.clear();
      window.location.reload();
    },

    async resendCode() {
      this.isResendButtonDisabled = true;
      await this.getResendToken();
      this.segundos = this.valorCode * 60;
      this.startCountdown();
      this.showResendButton = false;
      setTimeout(() => {
        this.isResendButtonDisabled = false;
      }, 3000); // Deshabilita por 3 segundos para evitar doble clic
    },
    startCountdown() {
      if (this.countdown) {
        clearInterval(this.countdown);
      }
      this.countdown = setInterval(() => {
        const minutos = Math.floor(this.segundos / 60);
        const segundosLo = this.segundos % 60;
        const formatoSegundos = segundosLo < 10 ? '0' + segundosLo : segundosLo;
        document.getElementById("countdown").innerHTML = minutos + " min " + formatoSegundos + " seg ";
        this.segundos--;

        if (this.segundos < 0) {
          clearInterval(this.countdown);
          document.getElementById("countdown").innerHTML = "¡Tiempo agotado!";
          this.showResendButton = true; 
        }
      }, 1000);
    },
    ...mapActions({
      postValidateToken: `${RECOVER_FORGOTTEN_PASSWORD_M}${ACTION_POST_VALIDATETOKEN}`,
      getResendToken: `${RECOVER_FORGOTTEN_PASSWORD_M}${ACTION_GET_RESENDTOKEN}`,
    }),

    async changeValidateCode() {
      const errors = this.validateForm();

      if (Object.keys(errors).length > 0) {
        const errorMessages = Object.values(errors).join('<br>');
        return Swal.fire({
          icon: 'error',
          title: 'Errores de validación',
          html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
      } else {
        await this.postValidateToken(this.formData.code)
      }
      this.dialog = false;
    },

    validateForm() {

      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.code || !alphanumericRule.test(this.formData.code) || this.formData.code.length !== 15) {
        errors.code = 'El formato del código es inválido';
      }

      return errors;
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 30vh;
}

.small-x {
  font-size: smaller;
}


.code-text {
  text-align: center;
  font-size: 15px;
  color: black;
}

.max-width-container {
  max-width: 800px;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

.containerTime {
  display: flex;
  flex-direction: column;
  align-items: left;
  color: #6E17A5;
  padding-left: 20px;
  padding-top: 20px;
  font-size: 15px;
  color: black;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }
}
</style>